// extracted by mini-css-extract-plugin
export var link = "_tn-0";